'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._blacklistedActions = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _redux = require('redux');

var _reduxSaga = require('redux-saga');

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _reduxLogger = require('redux-logger');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Actions from redux-saga to be excluded from other middlewares
var _blacklistedActions = exports._blacklistedActions = ['EFFECT_TRIGGERED', 'EFFECT_RESOLVED', 'EFFECT_REJECTED', 'LOAD_FULL', 'LOAD_FULL_SUCCESS'];

var createRootSaga = function createRootSaga(sagas, sagaParams) {
    return (/*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return sagas.map(function (saga) {
                                return saga(sagaParams);
                            });

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this);
        })
    );
};

exports.default = function (_ref) {
    var reducer = _ref.reducer,
        _ref$reducers = _ref.reducers,
        reducers = _ref$reducers === undefined ? {} : _ref$reducers,
        _ref$sagas = _ref.sagas,
        sagas = _ref$sagas === undefined ? [] : _ref$sagas,
        _ref$sagaParams = _ref.sagaParams,
        sagaParams = _ref$sagaParams === undefined ? {} : _ref$sagaParams,
        _ref$middlewares = _ref.middlewares,
        middlewares = _ref$middlewares === undefined ? [] : _ref$middlewares,
        initialState = _ref.initialState,
        _ref$useLogger = _ref.useLogger,
        useLogger = _ref$useLogger === undefined ? true : _ref$useLogger,
        _ref$blackListedRegex = _ref.blackListedRegexes,
        blackListedRegexes = _ref$blackListedRegex === undefined ? [] : _ref$blackListedRegex;

    // Configure logger to ignore the extra actions
    var sagaMiddleware = (0, _reduxSaga2.default)();

    var allMiddlewares = [].concat((0, _toConsumableArray3.default)(middlewares), [sagaMiddleware]);

    if (useLogger) {
        allMiddlewares.push((0, _reduxLogger.createLogger)({
            predicate: function predicate(getState, action) {
                var showLogger = _lodash2.default.get(getState(), 'session.showLogger', true);
                var ret = false;

                if (showLogger) {
                    if (_blacklistedActions.indexOf(action.type) !== -1) return false;

                    if (blackListedRegexes.length === 0) return true;

                    blackListedRegexes.forEach(function (blackRegex) {
                        if (blackRegex.exec(action.type)) ret = true;
                    });
                }

                return ret;
            }
        }));
    }

    reducer = reducer || (0, _redux.combineReducers)(reducers);
    var middleware = _redux.applyMiddleware.apply(undefined, (0, _toConsumableArray3.default)(allMiddlewares));
    var store = void 0;

    if (initialState) {
        store = (0, _redux.createStore)(reducer, initialState, middleware);
    } else {
        store = (0, _redux.createStore)(reducer, middleware);
    }

    sagaMiddleware.run(createRootSaga(sagas, sagaParams));

    return store;
};